<template>
  <div id="top" :class="$style.pricingPlan">
    <spacer :y="5"/>
    <p :class="$style.confidential">[ CONFIDENTIAL:導入校・導入企業向け ]</p>
    <h2>Welcome to talk サービス利用料・支払条件のご案内</h2>
    <p :class="$style.subtitle">適用：2026 年 4 月 1 日改定（税抜表示）</p>
    <spacer :y="0.25"/>
    <p :class="$style.description">※本案内は概要です。詳細は契約書および利用規約（教育機関向け/導入企業向け）に従います。各料金は予告なく変更する場合があります。</p>
    <spacer :y="4"/>

    <!-- 1. 各プランの説明 -->
    <ul :class="$style.contents">
      <li :class="$style.content">
        <div :class="$style.title">1. 各プランの説明（要点）</div>
        <spacer :y="1"/>
        <ul :class="$style.list">
          <li>
            スポットプラン（年次パターン）：年間のオンライン・テキスト健康相談の各相談回数を決めて年次運用
          </li>
          <li>
            スポットプラン（月次パターン）：毎月のオンライン健康相談の相談回数を決めて月次運用。テキスト健康相談の利用回数はオンライン健康相談の相談回数に準じて適用
          </li>
          <li>
            サステナブルプラン：全生徒（加入条件：500名以上）を対象としたアカウント課金プラン
            <div :class="$style.subitem">-月額200円/アカウント</div>
            <div :class="$style.subitem">- 1アカウント当たりのオンライン健康相談：心理士相談10回/年、医師相談2回/年</div>
            <div :class="$style.subitem">-テキスト健康相談：無制限利用</div>
          </li>
        </ul>
      </li>

      <!-- 2. 支払方法・請求 -->
      <li :class="$style.content">
        <div :class="$style.title">2. 支払方法・請求（共通）</div>
        <spacer :y="1"/>
        <ul :class="$style.list">
          <li>
            お支払い方法：当社指定口座へのお振込み（振込手数料はお客様負担）<br/>
            請求書：原則、締日の翌月「第4営業日まで」に発行
          </li>
        </ul>
      </li>

      <!-- 3. 回数の考え方 -->
      <li :class="$style.content">
        <div :class="$style.title">3. 回数の考え方（共通）</div>
        <spacer :y="1"/>
        <ul :class="$style.list">
          <li>スポットプランの医師によるオンライン健康相談は「医師相談1回＝2回換算」</li>
          <li>スポットプラン（月次パターン）：未利用回数の翌月持ち越し不可</li>
          <li>スポットプラン（年次パターン）：更新（契約延長）時に限り<span :class="$style.underline">未利用回数の持ち越し可</span></li>
        </ul>
      </li>

      <!-- 4. 料金表 -->
      <li :class="$style.content">
        <div :class="$style.title">4. 料金早見表（回数別・税抜）</div>
        <spacer :y="2"/>

        <!-- (1) スポットプラン：年次パターン -->
        <div :class="$style.tableWrapper">
          <p :class="$style.tableTitle">（1）スポットプラン：年次パターン</p>
          <table :class="$style.priceTable">
            <tbody>
              <tr>
                <td :class="$style.headerCell">基本料（初年度）</td>
                <td colspan="3">¥390,000</td>
              </tr>
              <tr>
                <td :class="$style.headerCell">オンライン健康相談<br/>（医師相談=2回換算）</td>
                <td>24 回</td>
                <td>48 回</td>
                <td>72 回</td>
              </tr>
              <tr>
                <td :class="$style.subHeaderCell">利用料/年</td>
                <td>¥210,000</td>
                <td>¥390,000</td>
                <td>¥530,000</td>
              </tr>
              <tr>
                <td :class="$style.headerCell">テキスト健康相談<br/>（上限回数/年）</td>
                <td>30 回</td>
                <td>60 回</td>
                <td>90 回</td>
              </tr>
              <tr>
                <td :class="$style.subHeaderCell">利用料/年</td>
                <td>¥80,000</td>
                <td>¥140,000</td>
                <td>¥190,000</td>
              </tr>
              <tr>
                <td :class="$style.headerCell">更新費用</td>
                <td colspan="3">¥150,000</td>
              </tr>
            </tbody>
          </table>
          <p :class="$style.tableNote">※導入後、契約期中に利用状況に応じた追加購入は可。追加月の前月15日までにお申し込みください</p>
          <p :class="$style.tableExample">例）初年度：基本契約39万円＋オンライン24回21万円＋テキスト30回8万円＝68万円</p>
        </div>

        <spacer :y="3"/>

        <!-- (2) スポットプラン：月次パターン -->
        <div :class="$style.tableWrapper">
          <p :class="$style.tableTitle">（2）スポットプラン：月次パターン</p>
          <table :class="[$style.priceTable, $style.monthlyPattern]">
            <tbody>
              <tr>
                <td :class="$style.headerCell">基本料（初年度）</td>
                <td colspan="6">¥390,000</td>
              </tr>
              <tr>
                <td :class="$style.headerCell">オンライン健康相談<br/>（医師相談=2回換算）</td>
                <td>12 回</td>
                <td>24 回</td>
                <td>36 回</td>
                <td>48 回</td>
                <td>60 回</td>
                <td>72 回</td>
              </tr>
              <tr>
                <td :class="$style.subHeaderCell">利用料/月</td>
                <td>¥110,000</td>
                <td>¥210,000</td>
                <td>¥305,000</td>
                <td>¥390,000</td>
                <td>¥465,000</td>
                <td>¥530,000</td>
              </tr>
              <tr>
                <td :class="$style.headerCell">テキスト健康相談<br/>（上限回数/月）</td>
                <td>15 回</td>
                <td>30 回</td>
                <td>45 回</td>
                <td>60 回</td>
                <td>75 回</td>
                <td>90 回</td>
              </tr>
              <tr>
                <td :class="$style.subHeaderCell">利用料/月</td>
                <td>➖</td>
                <td>➖</td>
                <td>➖</td>
                <td>➖</td>
                <td>➖</td>
                <td>➖</td>
              </tr>
              <tr>
                <td :class="$style.headerCell">更新費用</td>
                <td colspan="6">¥150,000</td>
              </tr>
            </tbody>
          </table>
          <p :class="$style.tableNote">※料金表の「➖」＝追加利用料なし（オンライン健康相談の利用料に含まれる）</p>
          <p :class="$style.tableExample">例）初月：基本契約39万円＋オンライン12回11万円（＋テキスト15回）＝50万円／2か月目以降：毎月11万円</p>
        </div>

        <spacer :y="3"/>

        <!-- (3) サステナブルプラン：アカウント課金 -->
        <div :class="$style.tableWrapper">
          <p :class="$style.tableTitle">（3）サステナブルプラン：アカウント課金</p>
          <table :class="$style.sustainableTable">
            <tbody>
              <tr>
                <td :class="$style.sustainableHeaderCell">利用料</td>
                <td>200円/アカウント・月（年額目安2,400円/アカウント）</td>
              </tr>
            </tbody>
          </table>
          <p :class="$style.tableExample">例）全生徒数が600名の場合：毎月600名×200円/月＝12万円</p>
        </div>
      </li>

      <!-- 5. プラン別：締日・支払期限 -->
      <li :class="$style.content">
        <div :class="$style.title">5. プラン別：締日・支払期限（概要）</div>
        <spacer :y="1"/>
        <table :class="$style.scheduleTable">
          <thead>
            <tr>
              <th>サービスプラン</th>
              <th>締日</th>
              <th>支払期限（原則）</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>スポットプラン（月次パターン）</td>
              <td>毎月末日</td>
              <td>翌月末日　※基本料は契約月の翌月末日まで</td>
            </tr>
            <tr>
              <td>スポットプラン（年次パターン）</td>
              <td>契約当月末日（年額）</td>
              <td>契約月の翌月末日まで（基本料＋利用料/年）</td>
            </tr>
            <tr>
              <td>サステナブルプラン</td>
              <td>毎月末日</td>
              <td>翌月末日まで</td>
            </tr>
          </tbody>
        </table>
      </li>

      <!-- 6. 各種手続き -->
      <li :class="$style.content">
        <div :class="$style.title">6. 各種手続き（概要）</div>
        <spacer :y="1"/>
        <ul :class="$style.list">
          <li>契約期間：契約日～翌3月31日（以後、1年更新）。中途解約は解約予定日の1か月前（2月末日）までの通知が必要</li>
          <li>契約更新：契約期間満了の1か月前までに何らかの意思表示がない場合は、1年間自動延長。以降同様</li>
          <li>スポットプラン（月次パターン）：利用回数のプラン変更は前月15日までの申込が必要（プランアップのみ等の運用ルールあり）</li>
        </ul>
      </li>
    </ul>

    <spacer :y="5"/>
    <div :class="$style.contact">
      <div :class="$style.contact_title"><strong>お問い合わせ</strong></div>
      <spacer :y="1"/>
      <p :class="$style.contact_text">
        株式会社 Welcome to talk<br>
        担当：経理担当<br>
        E-mail：<a href="mailto:admin-wtt@welcometotalk.co.jp">admin-wtt@welcometotalk.co.jp</a><br>
        TEL：03‐6403‐5333
      </p>
    </div>
    <spacer :y="5"/>
  </div>
</template>

<script>
import Spacer from '@/views/components/Spacer.vue';

export default {
  name: 'Pricing',
  components: {
    Spacer,
  },
};
</script>

<style lang="scss" module>
/* ============================================
   CSS変数（デザイントークン）
   ============================================ */
$color-text-primary: #333;
$color-text-secondary: #555;
$color-text-tertiary: #666;
$color-border: #000;
$color-border-heavy: 2px solid $color-border;
$color-background-light: #f0f0f0;

$font-size-base: inherit; // ブラウザデフォルト（約16px）を継承
$font-size-h2: 24px;
$font-size-title: 17px;
$font-size-subtitle: 15px;
$font-size-small: 14px;
$font-size-xsmall: 13px;
$font-size-count: 20px; // テーブル内の回数表示用

$spacing-xs: 4px;
$spacing-sm: 8px;
$spacing-md: 10px;
$spacing-lg: 20px;
$spacing-xl: 40px;

$table-header-width: 30%;
$table-border: 1px solid $color-border;
$table-cell-padding: 6px 10px;

/* ============================================
   ページ全体レイアウト
   ============================================ */
.pricingPlan {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 $spacing-lg;

  h2 {
    font-size: $font-size-h2;
    font-weight: bold;
    text-align: center;
    margin: $spacing-md 0;

    strong {
      font-weight: bold;
    }
  }

  p {
    margin: $spacing-sm 0;
  }
}

/* ============================================
   ヘッダーセクション（タイトル・説明文）
   ============================================ */
.confidential {
  font-size: $font-size-small;
  text-align: center;
  color: $color-text-tertiary;
  margin-bottom: $spacing-sm;
  font-weight: bold;
}

.subtitle {
  font-size: $font-size-subtitle;
  color: $color-text-primary;
  text-align: center;
  margin: $spacing-sm 0;
}

.description {
  font-size: $font-size-xsmall;
  color: $color-text-secondary;
  text-align: center;
  margin: $spacing-sm 0;
}

/* ============================================
   コンテンツセクション（リスト構造）
   ============================================ */
.title {
  font-weight: bold;
  font-size: $font-size-title;
  margin: $spacing-lg 0 $spacing-xs 0;
}

.contents {
  list-style: none;
  padding: 0;
  margin: 0;

  .content {
    &:not(:first-child) {
      margin-top: $spacing-xl;
    }
  }
}

.list {
  list-style: none;
  padding: 0;
  margin: $spacing-md 0;

  li {
    padding-left: $spacing-lg;
    position: relative;
    margin-bottom: $spacing-xs;

    &::before {
      position: absolute;
      left: 0;
      content: "• ";
    }

    strong {
      font-weight: bold;
    }
  }
}

.subitem {
  margin-left: $spacing-lg;
  margin-top: $spacing-xs;
}

.underline {
  text-decoration: underline;
}

/* ============================================
   テーブル共通スタイル
   ============================================ */
.tableWrapper {
  margin: $spacing-xs 0;
}

.tableTitle {
  font-weight: bold;
  font-size: $font-size-small;
  margin-bottom: $spacing-sm;
}

.tableNote {
  font-size: $font-size-xsmall;
  color: $color-text-tertiary;
  margin-top: 6px;
  text-align: left;
}

.tableExample {
  font-size: $font-size-xsmall;
  color: $color-text-primary;
  margin-top: $spacing-xs;
  text-align: left;
}

/* ============================================
   料金表テーブル（スポットプラン）
   ============================================ */
.priceTable {
  width: 100%;
  border-collapse: collapse;
  margin: $spacing-md;
  font-size: $font-size-small;
  border: $table-border;
  table-layout: fixed;

  td {
    border: $table-border;
    padding: $table-cell-padding;
    text-align: center;
    vertical-align: middle;
  }

  // ヘッダー列スタイル
  .headerCell,
  .subHeaderCell {
    font-weight: normal;
    text-align: center;
    padding: $table-cell-padding;
    border: $table-border;
    width: $table-header-width;
  }

  // データ列は自動幅
  td:not(.headerCell):not(.subHeaderCell) {
    width: auto;
  }

  // 回数表示セル（オンライン健康相談・テキスト健康相談の2行目と4行目）
  tbody tr:nth-child(2) td:not(.headerCell),
  tbody tr:nth-child(4) td:not(.headerCell) {
    font-size: $font-size-count;
  }

  // 基本料行の下線を強調
  tbody tr:first-child td {
    border-bottom: $color-border-heavy;
  }

  // 利用料行の下線を強調
  tbody tr:has(.subHeaderCell) td {
    border-bottom: $color-border-heavy;
  }

  // 月次パターンの特殊スタイル（列間の罫線強調）
  &.monthlyPattern {
    // オンライン健康相談とテキスト健康相談の回数列
    tbody tr:nth-child(2) td:not(.headerCell),
    tbody tr:nth-child(4) td:not(.headerCell) {
      border-right: $color-border-heavy;
    }

    // 利用料/月の列
    tbody tr:nth-child(3) td:not(.headerCell):not(.subHeaderCell),
    tbody tr:nth-child(5) td:not(.headerCell):not(.subHeaderCell) {
      border-right: $color-border-heavy;
    }

    // 最後のデータセルの右罫線は通常幅に戻す
    tbody tr:nth-child(2) td:not(.headerCell):last-child,
    tbody tr:nth-child(3) td:not(.headerCell):not(.subHeaderCell):last-child,
    tbody tr:nth-child(4) td:not(.headerCell):last-child,
    tbody tr:nth-child(5) td:not(.headerCell):not(.subHeaderCell):last-child {
      border-right: $table-border;
    }
  }
}

/* ============================================
   サステナブルプランテーブル
   ============================================ */
.sustainableTable {
  width: 100%;
  border-collapse: collapse;
  margin: $spacing-md;
  font-size: $font-size-small;
  border: $table-border;
  table-layout: fixed;

  td {
    border: $table-border;
    padding: $table-cell-padding;
    text-align: left;
    vertical-align: middle;
  }

  .sustainableHeaderCell {
    font-weight: normal;
    text-align: left;
    padding: $table-cell-padding;
    border: $table-border;
    width: $table-header-width;
  }
}

/* ============================================
   スケジュールテーブル（締日・支払期限）
   ============================================ */
.scheduleTable {
  width: 100%;
  border-collapse: collapse;
  margin: $spacing-md;
  font-size: $font-size-small;
  border: $table-border;
  table-layout: fixed;

  th, td {
    border: $table-border;
    padding: $table-cell-padding;
    text-align: left;
    vertical-align: middle;
  }

  thead th {
    background-color: $color-background-light;
    font-weight: bold;
    text-align: left;
    border: $table-border;

    &:nth-child(1) { width: 30%; }
    &:nth-child(2) { width: 30%; }
    &:nth-child(3) { width: 40%; }
  }

  tbody tr td {
    &:nth-child(1) { width: 30%; }
    &:nth-child(2) { width: 30%; }
    &:nth-child(3) { width: 40%; }
  }
}

/* ============================================
   お問い合わせセクション
   ============================================ */
.contact {
  background-color: var(--gray-sub);
  padding: 30px 40px 30px 30px;
  border-radius: 8px;
  display: inline-block;

  &_title {
    strong {
      font-weight: bold;
    }
  }

  &_text {
    padding-left: 10px;
    margin: 0;
    text-align: left;
  }
  &_text a {
    color: black;
    text-decoration: underline;
  }
}
</style>
